import React, { useState, useEffect } from "react";
import style from "../../style/DoctorSchedule.module.scss";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import PenToSquareRegular from "../Icon/PenToSquareRegular";
import dayjs from "dayjs";
import Logger from "../../libraries/Logger";
import DoctorDetailModal from "../Modal/DoctorDetailModal";
import { DoctorScheduleList } from "../../Data/DoctorScheduleList";

function DoctorScheduleListBody({ data }) {
  const [isOtherHospital, setIsOtherHospital] = useState(null);
  const [open, setOpen] = useState([]);
  const [cursor, setCursor] = useState(false);
  useEffect(() => {
    setIsOtherHospital(
      JSON.parse(localStorage.getItem("auth"))?.IsOtherHospital
    );
  }, [isOtherHospital]);

  const getDay = (DayValue, index) => {
    if (DayValue.isName === false) {
      return <li className={style.day}>{DayValue.DoctorName}</li>;
    } else {
      return (
        <li className={style.day}>
          <a href="#" className={style.duty_person}>
            {DayValue.DoctorName}
          </a>
          <div className={style.duty_tel} key={index}>
            {DayValue.subListData?.map((value, subindex) => {
              return (
                <div className={style.tel} key={subindex}>
                  {value}
                </div>
              );
            })}
          </div>
        </li>
      );
    }
  };
  const theadNeurologiesContent = [
    "時段",
    "日",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
  ];
  const theadIATeamContent = [
    // "職務",
    "時段",
    "日",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
  ];
  // console.log(data);
  const dateNeurologiesArray = data?.Neurologies.map((v) => {
    return { ...v, Date: new Date(v.Date) };
  });
  // console.log(dateNeurologiesArray);
  const dateIATeamArray = data?.IATeam.map((v) => {
    return { ...v, Date: new Date(v.Date) };
  });
  // console.log(dateIATeamArray);

  const weeksNeurologies = dateNeurologiesArray?.reduce((result, date) => {
    const weekStart = new Date(date.Date);
    weekStart.setDate(date.Date.getDate() - date.Date.getDay());
    const weekEnd = new Date(date.Date);
    weekEnd.setDate(date.Date.getDate() - date.Date.getDay() + 6);
    const weekKey = `${weekEnd.getFullYear()}-${
      weekEnd.getMonth() + 1
    }-${weekEnd.getDate()}`;
    const week = result[weekKey] || {
      dates: [],
      weekStartDay: new Date(date.Date).getDay(),
    };
    week.dates.push(date);
    return {
      ...result,
      [weekKey]: week,
    };
  }, {});

  // Add logic to fill the last week with 7 days
  const lastWeekKeyN =
    weeksNeurologies &&
    Object.keys(weeksNeurologies)[Object.keys(weeksNeurologies).length - 1];
  const lastWeekN = lastWeekKeyN && weeksNeurologies[lastWeekKeyN];
  const lastWeekDatesCountN = lastWeekN && lastWeekN.dates.length;

  if (lastWeekDatesCountN < 7) {
    const lastDate = lastWeekN.dates[lastWeekDatesCountN - 1].Date;
    const remainingDays = 7 - lastWeekDatesCountN;

    for (let i = 1; i <= remainingDays; i++) {
      lastWeekN.dates.push({ Date: null, List: [{}, {}, {}, {}] });
    }
  }

  const dataNeurologiesReset =
    weeksNeurologies && Object?.values(weeksNeurologies);

  const weeksIATeam = dateIATeamArray?.reduce((result, date) => {
    //dateIATeamArray // DoctorScheduleList
    const weekStart = new Date(date.Date);
    weekStart.setDate(date.Date.getDate() - date.Date.getDay());
    const weekEnd = new Date(date.Date);
    weekEnd.setDate(date.Date.getDate() - date.Date.getDay() + 6);
    const weekKey = `${weekEnd.getFullYear()}-${
      weekEnd.getMonth() + 1
    }-${weekEnd.getDate()}`;
    const week = result[weekKey] || {
      dates: [],
      weekStartDay: new Date(date.Date).getDay(),
    };
    week.dates.push(date);
    return {
      ...result,
      [weekKey]: week,
    };
  }, {});

  // Add logic to fill the last week with 7 days
  const lastWeekKey =
    weeksIATeam &&
    Object.keys(weeksIATeam)[Object.keys(weeksIATeam).length - 1];
  const lastWeek = lastWeekKey && weeksIATeam[lastWeekKey];
  const lastWeekDatesCount = lastWeek && lastWeek.dates.length;

  if (lastWeekDatesCount < 7) {
    const lastDate = lastWeek.dates[lastWeekDatesCount - 1].Date;
    const remainingDays = 7 - lastWeekDatesCount;

    for (let i = 1; i <= remainingDays; i++) {
      lastWeek.dates.push({ Date: null, List: [{}, {}, {}, {}] });
    }
  }

  // Print the updated weeksIATeam object
  const dataIATeamsReset = weeksIATeam && Object?.values(weeksIATeam);

  return (
    <div className={style.duty_info}>
      <div className={style.duty_calender}>
        <div className={style.duty}>
          <div className={style.duty_title}>神內值班醫師</div>
        </div>

        <table className={style.table} style={{ tableLayout: "fixed" }}>
          <thead>
            <tr className={style.table_title}>
              {theadNeurologiesContent?.map((v, i) => {
                return (
                  <th
                    className={style.table_title_self}
                    key={i}
                    style={{ color: "#575757" }}
                  >
                    {v}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {dataNeurologiesReset?.map((weekV, weekI) => {
              return (
                <tr className={style.table_body} key={weekI}>
                  <td className={style.table_body_self}>
                    <div style={{ color: "#575757" }}>日期</div>
                    <div style={{ color: "#575757" }}>08至13</div>
                    <div style={{ color: "#575757" }}>13至17</div>
                    <div style={{ color: "#575757" }}>17至20</div>
                    <div style={{ color: "#575757" }}>20至08</div>
                  </td>
                  {Array(weekV?.weekStartDay)
                    .fill(1)
                    .map((day, i) => {
                      return (
                        <td key={i} className={style.table_body_self}>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </td>
                      );
                    })}
                  {weekV?.dates?.map((dayV, dayI) => {
                    return (
                      <td className={style.table_body_self} key={dayI}>
                        <div style={{ color: "#c5c6c7" }}>
                          {dayV.Date === null ? "" : dayV.Date.getDate()}
                        </div>
                        {dayV?.List?.map((timeV, timeI) => {
                          return (
                            <div
                              style={{
                                cursor: cursor ? "no-drop" : "pointer",
                                color: " #1675e0",
                              }}
                              key={timeI}
                              onClick={() => {
                                if (timeV?.Name != null) {
                                  setOpen([
                                    { open: true },
                                    { title: "神內值班醫師" },
                                    { Identity: timeV?.Identity },
                                    { name: timeV?.Name },
                                    {
                                      number: [
                                        timeV?.PhoneNumber,
                                        timeV?.ShortNumber,
                                        timeV?.ExtensionNumber,
                                      ],
                                      time: [
                                        timeV?.StartDateTime,
                                        timeV?.EndDateTime,
                                      ],
                                    },
                                  ]);
                                }
                              }}
                              onMouseEnter={() => {
                                if (timeV?.Name == null) {
                                  setCursor(true);
                                }
                              }}
                              onMouseLeave={() => {
                                setCursor(false);
                              }}
                            >
                              {timeV?.Name}
                            </div>
                          );
                        })}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className={style.duty_calender}>
        <div className={style.duty}>
          <div className={style.duty_title}>取栓值班醫師</div>
        </div>
        <table className={style.table} style={{ tableLayout: "fixed" }}>
          <thead>
            <tr className={style.table_title}>
              {theadIATeamContent?.map((v, i) => {
                return (
                  <th
                    className={style.table_title_self}
                    key={i}
                    style={{ color: "#575757" }}
                  >
                    {v}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {dataIATeamsReset?.map((weekV, weekI) => {
              return (
                <tr className={style.table_body} key={weekI}>
                  {/* <td className={style.table_body_self}>
                    <div style={{ color: "#575757" }}></div>
                    <div style={{ color: "#575757", height: "52px" }}>醫師</div>
                    <div style={{ color: "#575757" }}>放射師</div>
                    <div style={{ color: "#575757" }}>護理師</div>
                  </td> */}
                  <td className={style.table_body_self}>
                    <div>日期</div>
                    <div>08至12</div>
                    <div>12至16</div>
                    <div>16至20</div>
                    <div>20至08</div>
                  </td>
                  {Array(weekV?.weekStartDay)
                    .fill(1)
                    .map((day, i) => {
                      return (
                        <td key={i} className={style.table_body_self}>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </td>
                      );
                    })}
                  {weekV?.dates?.map((dayV, dayI) => {
                    return (
                      <td className={style.table_body_self} key={dayI}>
                        <div style={{ color: "#c5c6c7" }}>
                          {dayV.Date === null ? "" : dayV.Date.getDate()}
                        </div>
                        {dayV?.List?.map((timeV, timeI) => {
                          return (
                            <div
                              style={{
                                cursor: cursor ? "no-drop" : "pointer",
                                color: " #1675e0",
                              }}
                              key={timeI}
                              onClick={() => {
                                console.log(timeV);
                                if (timeV?.Name != null) {
                                  setOpen([
                                    { open: true },
                                    { title: "取栓值班醫師" },
                                    { Identity: timeV?.Identity },
                                    { name: timeV?.Name },
                                    {
                                      number: [
                                        timeV?.PhoneNumber,
                                        timeV?.ShortNumber,
                                        timeV?.ExtensionNumber,
                                      ],
                                      time: [
                                        timeV?.StartDateTime,
                                        timeV?.EndDateTime,
                                      ],
                                    },
                                  ]);
                                }
                              }}
                              onMouseEnter={() => {                            
                                if (timeV?.Name == null) {
                                  setCursor(true);
                                }
                              }}
                              onMouseLeave={() => {
                                setCursor(false);
                              }}
                            >
                              {timeV?.Name}
                            </div>
                          );
                        })}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        {/* <ul className={style.calender_titles}>
            {data?.RightListTitle?.map((v, i) => {
              return (
                <li className={style.calender_title} key={i}>
                  {v}
                </li>
              );
            })}
          </ul>
          <div className={style.week}>
            {data?.RightListDatas?.map((v, i) => {
              return (
                <ul className={style.days} key={i}>
                  <li className={style.time}>{v.job}</li>
                  {getDay(v.day1, i)}
                  {getDay(v.day2, i)}
                  {getDay(v.day3, i)}
                  {getDay(v.day4, i)}
                  {getDay(v.day5, i)}
                  {getDay(v.day6, i)}
                  {getDay(v.day7, i)}
                </ul>
              );
            })}
          </div> */}
      </div>
      <DoctorDetailModal open={open} setOpen={setOpen} />
    </div>
  );
}

export default DoctorScheduleListBody;
